import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  getCallStatusClassName,
  getCallStatusLabelKey,
  normalizeCallStatus,
} from '../../../lib/utils/callStatus';
import { cn } from '../../../utils/cn';

const CallStatusBadge = ({ status, size = 'sm', className }) => {
  const { t } = useTranslation();
  const value = normalizeCallStatus(status);

  if (!value) {
    return (
      <span className="text-sm text-muted-foreground">{t('common.emDash')}</span>
    );
  }

  const labelKey = getCallStatusLabelKey(value);
  const label = labelKey ? t(labelKey) : value;
  const sizeClass = size === 'md' ? 'px-3 py-1 text-sm' : 'px-2.5 py-0.5 text-xs';

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full font-medium border whitespace-nowrap',
        sizeClass,
        getCallStatusClassName(value),
        className,
      )}
    >
      {label}
    </span>
  );
};

export default CallStatusBadge;
